var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var throttle = require('lodash.throttle');

function Header(el) {
	var t = this;

	t.$el = $(el);
	t.headerHeight = 60;
	t.$document = $(document);
	t.$body = $('body');
	t.$html = $('html');
	t.$main = $('.main');
	t.$menu = t.$el.find('.header__menu');
	t.$toggle = t.$el.find('.js-nav-trigger');
	t.$menuItems = t.$el.find('.menu-item-has-children > a');
	t.$allMenuItems = t.$el.find('.menu-item > a');
	t.$activeMenuItems = t.$el.find('.current-menu-item');
	t.$searchIcon = t.$el.find('.js-search-enable');
	t.$searchCloseIcon = $('.js-search-disable');
	t.$window = $(window);

	// Update fixed header
	t.onTop();
	t.$document.on('scroll', throttle(t.onTop.bind(t), 200));

	// Toggle menu active in mobile
	if( t.$toggle.length ) {
		t.$toggle.on('click', function() {
			t.$html.toggleClass('js-menu-active');
		});
	}

	// Enable dropdown menu
	if( t.$menuItems.length ) {
		t.$menuItems.on('click', function(e) {
			var $link = $(this);

			if (t.$window.width() <= 768) {
				e.preventDefault();
				$link.parent().toggleClass('menu-item--open').siblings().removeClass('menu-item--open');
			}
		});

		t.$el.find('.menu-item-has-children ul li a').on('click', function() {
			$(this).closest('.menu-item-has-children').toggleClass('menu-item--open');
			var $this = $(this),
			href = $this.attr('href'),
			hash = href.substring(href.indexOf('#')+1);
			var $page = t.$main.find('[name="' + hash + '"]');
			$page[0].focus();
		});

		// Enable press space key to open submenu
    t.openSubmenu = function($parent) {
      var $link = $parent.find('> a');

      if ($parent.hasClass('menu-item-has-children')) {
        $link.attr('aria-expanded', 'true');
        $parent.addClass('menu-item--open');
      }
    };

    t.closeSubmenu = function($parent) {
      $parent.each(function($index, $item) {
        var $link = $($item).find('> a');
        if ($($item).hasClass('menu-item-has-children')) {
          $link.attr('aria-expanded', 'false');
          $($item).removeClass('menu-item--open');
        }
      });
    };

    t.toggleSubmenu = function($parent) {
      if ($parent.hasClass('menu-item--open')) {
        t.closeSubmenu($parent);
      } else {
        t.openSubmenu($parent);
      }
    };

    t.$allMenuItems.on('focus', function(e) {
      var $link = $(this);

      t.openSubmenu($link.parent());
      t.closeSubmenu($link.parent().siblings());
    });

    t.$allMenuItems.last().on('blur', function(e) {
			t.closeSubmenu(t.$el.find('.menu-item'));
		});

    $(document).on('click', function(e) {
      if (!t.$menu.is(e.target) && !t.$menu.has(e.target).length) {
        t.closeSubmenu(t.$el.find('.menu-item-has-children'));
      }
    });
	}

	// Remove active on same link if matching hash
	if( t.$activeMenuItems ) {
		var link = t.$activeMenuItems.find('> a').attr('href'),
			children = t.$activeMenuItems.find('.menu-item a');

		if( link != undefined && children.length ) {
			children.each( function() {
				var $this = $(this),
					href = $this.attr('href'),
					hash = href.substring(href.indexOf('#')+1);

				// Add smooth scroll in current active page
				if( hash.length ) {
					$this.on('click', function(event) {
						var $page = t.$main.find('[name="' + hash + '"]');
						if( $page.length ) {
							event.preventDefault();
							t.smoothScroll($page);
						}
					});
				}
			} );
		}
	}

	// Enable search
	if( t.$searchIcon.length ) {
		t.$searchIcon.on('click',  function() {
			t.$html.addClass('js-search-active').trigger('searchActive');
		});
	}

	t.$html.on('searchInactive', function() {
    t.$searchIcon.focus();
  });

	// Find location hash and smooth scroll
	if( window.location.hash ) {
		// Fragment exists
		var $target = t.$main.find('[name="' + window.location.hash.slice(1) + '"]');
		if( $target.length ) {
			$(window).load(function() {
				t.smoothScroll($target);
			});
		}
	}

	$(window).on('load', function () {
		var hash = window.location.hash;
		if (hash !== '') {
			setTimeout(function () {
				var id = hash.replace('#', '');
				var element = document.getElementById(id);
				if (element && element.scrollIntoView) {
					element.scrollIntoView();
				}
			}, 0);
		}
	});
}

Header.prototype.smoothScroll = function(target) {
	var t = this;
	var offset = target.offset().top - parseFloat(t.$el.css('paddingTop')) - t.$menu.height() - 1;
	$('html, body').animate({
		scrollTop: offset
	}, 1000);
	return false;
};

Header.prototype.toggleFixedHeader = function(condition) {
	this.$body.toggleClass('fixed-header', condition);
};

Header.prototype.onTop = function() {
	var t = this;
	t.toggleFixedHeader(t.$document.scrollTop() > t.$el.height());
};

module.exports = Header;
